import React from "react";
import { motion } from "framer-motion";
import bgGreen from "../../assets/layer-bg-green.png";

export const ProblemsSection: React.FC = () => {
  const categories = [
    {
      id: "01",
      title: "Akıllı Kaynak Yönetimi ve Sürdürülebilirlik",
      description:
        "Su, enerji ve gübrenin verimli kullanımını sağlayan; sensör, meteoroloji verisi ve otomatik kontrol sistemleri ile israfı azaltan çözümler.",
      tags: ["Toprak Nemi", "Sensör Ağları", "Otomatik Sulama", "Sürdürülebilirlik"],
    },
    {
      id: "02",
      title: "Hassas Tarım Teknolojileri",
      description:
        "Uydu ve saha verileriyle tarlanın ihtiyaç duyulan bölgesine müdahale eden, bitki sağlığını izleyen ve optimizasyon sağlayan yaklaşımlar.",
      tags: ["Drone", "Uydu Verisi", "Hastalık Tespiti", "Bölgesel Analiz"],
    },
    {
      id: "03",
      title: "Tarımsal Mekanizasyon ve Otonom Sistemler",
      description:
        "İnsan gücüne bağımlılığı azaltan, tarlada konumlandırma destekli ekim-bakım-hasat yapabilen akıllı araç ve platform çözümleri.",
      tags: ["Otonom Araç", "Konumlandırma", "Robotik", "Tarla Operasyonu"],
    },
    {
      id: "04",
      title: "Dijital Tarım ve Karar Destek Sistemleri",
      description:
        "Çiftçilerin veri temelli karar almasını kolaylaştıran; risk uyarı, rekolte tahmini ve tedarik zinciri iyileştirmesi sunan platformlar.",
      tags: ["Erken Uyarı", "Rekolte Tahmini", "İklim Adaptasyonu", "Karar Desteği"],
    },
    {
      id: "05",
      title: "Biyoteknoloji ve Tohum/Gen Teknolojisi",
      description:
        "Islah süreçlerinde biyoteknolojik yöntemler, iklim stresine dayanıklı tohum geliştirme ve verimi artıran yenilikçi gen teknolojisi yaklaşımları.",
      tags: ["Tohum Islahı", "CRISPR", "Gıda Güvenliği", "Biyoteknoloji"],
    },
  ];

  return (
    <section
      id="categories"
      className="lg:min-h-screen px-4 sm:px-6 lg:px-8 py-10 sm:py-12 lg:py-16 bg-[var(--bg-primary)] relative overflow-hidden flex items-center"
    >
      <img src={bgGreen} alt="" aria-hidden className="pointer-events-none absolute -right-16 top-16 h-[380px] w-[380px] opacity-15 blur-[1px]" />
      <div className="max-w-7xl mx-auto">
        <div className="mb-7 sm:mb-10 max-w-4xl mx-auto text-center">
          <h2 className="text-4xl sm:text-5xl font-black leading-[1.05] tracking-[-0.02em] mb-4">
            <span className="text-[var(--text-primary)]">Tarım Odak Alanları</span>
          </h2>
          <div className="w-24 h-1 mx-auto rounded-full mb-6 bg-[#73E03A]" />
          <p className="text-[var(--text-secondary)] text-sm sm:text-lg leading-relaxed">
            Ekipler beş ana odak alanında çözüm üretecek; her bir alan yüksek etki
            potansiyeline sahip agritech problemlerine odaklanır.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4 lg:gap-5">
          {categories.map((item, idx) => (
            <motion.article
              key={item.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -8, scale: 1.02 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.08, type: "spring", stiffness: 200, damping: 18 }}
              className="kapsul-card p-4 sm:p-5"
            >
              <div className="flex items-start gap-4">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#73E03A]/15 text-[#245314] font-bold">
                  {item.id}
                </span>
              </div>
              <h3 className="mt-3 sm:mt-4 text-base sm:text-lg font-bold text-[var(--text-primary)]">{item.title}</h3>
              <p className="mt-2 text-xs sm:text-sm text-[var(--text-secondary)]">{item.description}</p>
              <div className="mt-3 sm:mt-4 flex flex-wrap gap-2">
                {item.tags.map((tag, tagIdx) => (
                  <span
                    key={tag}
                    className={`kapsul-badge px-2.5 sm:px-3 py-1 text-[10px] sm:text-xs border ${tagIdx > 1 ? "hidden sm:inline-flex" : "inline-flex"}`}
                    style={{ backgroundColor: "rgba(115,224,58,0.12)", borderColor: "rgba(115,224,58,0.35)", color: "#2F7A16" }}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
